<template>
  <RouterView />
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  mounted() {
    let localData = JSON.parse(localStorage.getItem('user'))
    if(localData === null || localData.colormode == "auto"){
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.setAttribute("data-bs-theme", "dark");
      }

      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
        const newColorScheme = event.matches ? "dark" : "light";
        if (newColorScheme == "dark") {
          document.documentElement.setAttribute("data-bs-theme", "dark");
        } else {
          document.documentElement.setAttribute("data-bs-theme", "light");
        }
      });
    } else {
      document.documentElement.setAttribute("data-bs-theme", localData.colormode);
    }
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
}
.btn-primary {
  background-color: #3a86ff;
}
</style>
